export default __webpack_public_path__ + "static/media/list.c207a043.svg";